'use client'

import KachLogo from 'ui/components/KachLogo'
import { ArrowRightIcon } from 'lucide-react'
import Link from 'next/link'

export default function Error({
  error,
  reset,
}: {
  error: Error
  reset: () => void
}) {
  return (
    <div className='flex flex-col items-center justify-center h-screen'>
      <KachLogo size='4rem' variant='primary' />
      <div className='mt-12 flex flex-col items-center justify-center text-center'>
        <div>
          <span className='text-4xl font-bold'>500 - Error de servidor</span>
          <p className='text-gray-500'>
            Lo sentimos, algo salió mal. Recarga la página o comunicate con
            nosotros si el problema persiste
          </p>
        </div>
        <Link className='mt-12' href='/'>
          Volver al inicio <ArrowRightIcon className='inline w-5 h-5' />
        </Link>
      </div>
    </div>
  )
}
